<!--div qui couvre tout le composant pour le vérouiller (si disabled)-->
<div *ngIf="disabled" class="lock-config-buttons"></div>

<div class="w-100 q-card py-0">
  <div class="row">
    <!--#region colonne éléments NON SELECTIONNES-->
    <div class="col-sm-6" style="min-height: 200px;">
      <!--#region titre-->
      <div #TitleContainer class="col-12 p-0">
        <h5 *ngIf="elementsColumName" class="mt-2 mb-0 q-bold">{{elementsColumName}}</h5>
      </div>
      <!--#endregion-->
      <!--#region filtre-->
      <div #ListFilterContainer class="row px-3 mt-2">
        <input *ngIf="filterableProperties && filterableProperties.length > 0" type="text" [(ngModel)]="filter" class="q-input-border col"
               style="margin-top: 8px; margin-bottom: 0px;" placeholder="filtrer" />
      </div>
      <!--#endregion-->
      <!--#region liste des éléments-->
      <!--fait 100% de la hauteur du container MOINS la hauteur du titre et du filtre (et 30px pour la marge)-->
      <div class="col-12 p-0" style="margin-top:8px;" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100% - ' + (TitleContainer.offsetHeight + ListFilterContainer.offsetHeight + 30) + 'px)')">

        <cdk-virtual-scroll-viewport class="h-100" itemSize="33">
          <ng-container *cdkVirtualFor="let element of elementsList | FilterElements:filter :filterableProperties">
            <div class="w-100 d-flex align-items-center grip-container"
                 style="flex-wrap:wrap;">
              <!--bouton "+" pour ajouter les éléments-->
              <i (click)="AddElement(element.value, element.index)"
                 class="fas fa-plus-circle q-c-success col-auto p-0 pl-1 q-pointer"></i>
              <!--html à injecter depuis le composant parent-->
              <ng-container *ngIf="elementListRef"
                            [ngTemplateOutlet]="elementListRef"
                            [ngTemplateOutletContext]="{$implicit:element.value, index: element.index}">
              </ng-container>
            </div>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      
      </div>
      <!--#endregion-->
    </div>
    <!--#endregion-->
    <!--#region colonne éléments SELECTIONNES-->
    <div class="col-sm-6" style="min-height: 200px;">
      <!--#region titre-->
      <div #ListBodyContainer class="col-12 p-0">
        <h5 *ngIf="selectedElementsColumName" class="mt-2 mb-0 q-bold">{{selectedElementsColumName}}</h5>
      </div>
      <!--#endregion-->
      <!--#region liste des éléments-->
      <!--fait 100% de la hauteur du container MOINS la hauteur du titre (et 30px pour la marge)-->
      <div class="col-12 list-container"
           [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100% - ' + (ListBodyContainer.offsetHeight + 30) + 'px)')">
        <ng-container *ngFor="let element of selectedElementsList; let index = index;">
          <div class="row grip-container align-items-center">
            <!--bouton "-" pour retirer les éléments-->
            <i (click)="RemoveElement(element, index)"
               class="fas fa-minus-circle q-c-danger col-auto p-0 pl-1 q-pointer"></i>
            <!--html à injecter depuis le composant parent-->
            <ng-container *ngIf="elementSelectedRef"
                          [ngTemplateOutlet]="elementSelectedRef"
                          [ngTemplateOutletContext]="{$implicit:element, index: index}">
            </ng-container>
          </div>
        </ng-container>
      </div>
      <!--#endregion-->
    </div>
    <!--#endregion-->
  </div>
</div>
